@if (viewModel) {
    @if (showBetBuilderNotification && viewModel.betBuilderNotification) {
        <bs-linear-bet-builder-notification [betBuilderNotification]="viewModel.betBuilderNotification" />
    }
    @if (isOfferChanged) {
        <bs-linear-odds-change-notification [isPlacementError]="viewModel.isBetPlacementOfferChanged" />
    }
    @if (viewModel.hasComboPrevention && viewModel.betslipType) {
        <bs-linear-combo-prevention-notification [betslipType]="viewModel.betslipType" />
    }
    @if (showBetslipErrors) {
        <bs-linear-errors-list [viewModel]="viewModel.errors" [tokensContext]="tokensContext" />
    }
}
